import OnedocAiPage from './OnedocAiView';
import AiChatProvider from './AiChatProvider';

export { AiChatProvider };
export default OnedocAiPage;
